import { render, staticRenderFns } from "./cart-table.vue?vue&type=template&id=001138ff&scoped=true&lang=pug"
import script from "./cart-table.js?vue&type=script&lang=js&external"
export * from "./cart-table.js?vue&type=script&lang=js&external"
import style0 from "./cart-table.vue?vue&type=style&index=0&id=001138ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001138ff",
  null
  
)

export default component.exports